import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  cardHeadingWrapper: {
    gap: theme.spacing(2),
  },
  sectionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    height: 'auto',
  },
  name: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(4),
  },
  textHeading: {
    color: '#381E1C',
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.25px',
  },
}))
